import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AttendanceModalData, AttendanceRegistration } from '../../models';
import { AttendanceService } from '../../service/attendance.service';
import { apiErrorMessage } from '../../utils/api-error';

@Component({
  selector: 'app-attendance-modal',
  templateUrl: './attendance-modal.component.html',
  styleUrls: ['./attendance-modal.component.scss'],
})
export class AttendanceModalComponent {
  @ViewChild('codeInput') codeInput: ElementRef<HTMLInputElement>;

  isSubmitting = false;
  form = this.formBuilder.group({
    code: ['', Validators.required],
  });

  private readonly NOTIFICATION_DURATION_MS = 5000;
  private readonly RETRYABLE_STATUSES: number[] = [
    HttpStatusCode.BadRequest,
    HttpStatusCode.Conflict,
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AttendanceModalData,
    private dialogRef: MatDialogRef<AttendanceModalComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private attendanceService: AttendanceService
  ) {}

  submit(): void {
    if (this.form.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.attendanceService
      .registerAttendance(this.data.trainingId, this.form.value.code!.trim())
      .subscribe({
        next: ({ attendanceRegistration }) => {
          this.isSubmitting = false;
          this.handleSuccess(attendanceRegistration);
        },
        error: (error: HttpErrorResponse) => {
          this.isSubmitting = false;
          this.handleError(error);
        },
      });
  }

  private handleSuccess(registration: AttendanceRegistration): void {
    this.showNotification(
      `Tu asistencia a ${registration.className} fue registrada satisfactoriamente.`,
      'snackbar-success'
    );
    this.dialogRef.close(true);
  }

  private handleError(error: HttpErrorResponse): void {
    this.showNotification(
      apiErrorMessage(
        error,
        'No pudimos registrar tu asistencia. Por favor intentá nuevamente.'
      ),
      error.status === HttpStatusCode.Conflict
        ? 'snackbar-warning'
        : 'snackbar-error'
    );

    if (this.RETRYABLE_STATUSES.includes(error.status)) {
      this.resetCode();
    }
  }

  private resetCode(): void {
    this.form.reset();
    this.codeInput?.nativeElement.focus();
  }

  private showNotification(message: string, panelClass: string): void {
    this.snackBar.open(message, 'Cerrar', {
      duration: this.NOTIFICATION_DURATION_MS,
      panelClass: panelClass,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
